import Repository from "../../repository";

export default {
    CabinetAction: (payload) => Repository.post(`/api/WaterwayActions/CabinetAction`, payload),
    EditSchedule: (payload) => Repository.post(`/api/WaterwayActions/EditSchedule`, payload),
}
